import { AppTextField, AppTextFieldProps } from 'components/base'
import { FC } from 'react'

interface Props extends Omit<AppTextFieldProps, 'control' | 'name'> {
  control?: any
  name?: string
  webSiteValue: string | undefined
}
export const WebsiteField: FC<Props> = ({ control, name, webSiteValue, ...rest }) => {
  return (
    <AppTextField
      control={control}
      name={name!}
      {...rest}
      suffixIcon={'streamline:browser-website-1'}
      suffixIconPropDynamic={(val) => {
        return {
          onClick: () => {
            if (!!val) {
              let url = val
              if (!url.startsWith('http://') && !url.startsWith('https://')) {
                url = 'https://' + url
              }
              window.open(url, '_blank')
            }
          },
          color: !!val ? 'blue' : '',
        }
      }}
    />
  )
}
